import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HighlightModule } from 'ngx-highlightjs';
import json from 'highlight.js/lib/languages/json';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { HomeContentComponent } from './pages/home/components/home-content/home-content.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbSidebarModule, NbMenuModule, NbLayoutModule, NbDatepickerModule, NbToastrModule, NbDialogModule, NbIconModule, NbButtonModule, NbWindowModule, NbTreeGridModule, NbInputModule, NbRadioModule  } from '@nebular/theme';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AuthGuard } from './auth/auth.guard';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StationsService } from './services/stations/stations.service';
import { LogoutComponent } from './@theme/components/logout/logout.component';
import { NoCacheHeadersInterceptor, UserService } from './services/user/user.service';
import { DiscountsService } from './services/discounts/discounts.service';
import { DealerService } from './services/dealer/dealer.service';
import { AgmCoreModule } from '@agm/core';
import { CarService } from './services/car/car.service';
import { LandingPageComponent } from './pages/home/landing-page/landing-page.component';
import { DatePipe } from '@angular/common';
import { JwtInterceptor } from './services/username-interceptor';

export function hljsLanguages() {
  return [{ name: 'json', func: json }];
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomeContentComponent,
    LandingPageComponent,
    LogoutComponent,
    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    HighlightModule.forRoot({
      languages: hljsLanguages
    }),
    FontAwesomeModule,
    NbThemeModule.forRoot(),
    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbLayoutModule,
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDialogModule.forChild(),
    NbButtonModule,
    NbIconModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBPivBONeROKIU65AxYfRDHySo3LXnxcgk',
      libraries: ['places']
    }),
    NbWindowModule.forChild(),
    NbTreeGridModule,
   NbInputModule,
   NbRadioModule  ],
  providers: [AuthGuard, StationsService, UserService, DiscountsService, DealerService, CarService, DatePipe
    , { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    ,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
